<template>
<v-card>
    <v-card-title>Suggest something new</v-card-title>

    <v-card-text>
        <notifications position="bottom right" group="items" />

        <p>You can propose new stuff, they will appear in the event as soon as reviewed and approved.</p>
        <v-form v-model="valid">
            <v-row>
                <v-col>
                    <v-text-field v-model="formData.item_title" id="title" label="Title" :rules="validateTitle">
                    </v-text-field>
                </v-col>
                <v-col v-if="eventTypes">
                    <v-select :items="eventTypes" item-text="event_type_name" item-value="id" v-model="formData.item_event_type" label="Type" :rules="validateType"></v-select>
                </v-col>
            </v-row>
        </v-form>
    </v-card-text>
    <v-card-actions>
        <v-btn v-if="!loading" :disabled="!valid" @click="save">Save</v-btn>
        <SmallLoaderLight v-if="loading" />
    </v-card-actions>
</v-card>
</template>

<script>
import SmallLoaderLight from "@/components/atoms/SmallLoaderLight";
import {
    mapState
} from "vuex";

export default {
    components: {
        SmallLoaderLight,
    },
    props: ["event"],

    data() {
        return {
            date: null,
            loading: false,
            error: null,
            valid: null,
            el: 1,
            setStartTime: true,
            formData: {
                item_title: "",
                item_event_type: null,
            },
            validateTitle: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 250) || 'Name must be less than 250 characters',
            ],
            validateType: [
                v => !!v || 'Type is required',
            ],
        };
    },
    computed: mapState({
        error: (state) => state.errors.createEvent,
        ownProfile: (state) => state.profiles.ownProfile,
        eventTypes: (state) => state.events.types,
        ownInvitation() {
            return this.event.invitations.find((e) => e.invitee.id == this.ownProfile.id)
        },

    }),
    methods: {
        async save() {

            if (
                !this.formData.item_title ||
                !this.formData.item_event_type
            ) {
                this.error =
                    "Fields missing";
                return;
            }
            this.formData.item_name = this.formData.item_title;
            this.formData.item_status = 'DR';
            // if (this.ownProfile.is_superuser == true) {
            //     this.formData.item_status = 'PU';
            // }
            this.loading = true;
            let action = 'createMiscellaneous';

            if (this.eventTypes.find(e => e.id == this.formData.item_event_type)['event_type_name'] == 'game') {
                action = 'createGames';
            }
            this.formData.invitation = this.ownInvitation.id
            await this.$store
                .dispatch(action, this.formData)
                .then((data) => {
                    if (data.success) {
                        this.$notify({
                            group: 'items',
                            title: "created!",
                            type: 'success',
                            text: 'New item created, it will be available after validation.'
                        })
                        let items = this.ownInvitation.items.map(e => e.item_id)
                        // Add the newly suggested item to the list.
                        items.push(data.data.item_id)

                    } else {
                        let error_msg = "Sorry it's not possible";
                        if (data && data.data && data.data.non_field_errors && data.data.non_field_errors[0]) {
                            error_msg = data.data.non_field_errors[0]
                        }
                        this.$notify({
                            group: 'items',
                            title: "error",
                            type: 'error',
                            text: error_msg,
                        })
                    }
                    this.loading = false;
                    this.formData = {
                        item_title: "",
                        item_event_type: null,
                    }

                });
        },
    },
};
</script>
